<!--
Copyright 2023 The Ground Authors.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
-->

<div class="loi-panel" [ngClass]="{ loading: isLoading() || isDeleting() }">
  <div *ngIf="isLoading() || isDeleting()" class="progress-spinner">
    <mat-spinner mode="indeterminate" diameter="50"></mat-spinner>
  </div>

  <ng-container *ngIf="!isLoading() && !isDeleting()">
    <div class="loi-panel-header">
      <div class="loi-panel-header-left">
        <mat-icon
          svgIcon="{{ icon() }}"
          [ngStyle]="{ color: iconColor() }"
        ></mat-icon>
        <div class="loi-panel-header-title">{{ name() }}</div>
      </div>

      <button
        mat-icon-button
        *ngIf="
          hasProperties() ||
          canDeleteSubmissions() ||
          canDeleteLocationOfInterest()
        "
        [matMenuTriggerFor]="menu"
        aria-label="Site options"
        i18n-aria-label="@@app.loiPanel.options"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button
          mat-menu-item
          *ngIf="hasProperties()"
          (click)="openPropertiesDialog($event)"
        >
          <mat-icon>data_info_alert</mat-icon>
          <span i18n="@@app.loiPanel.metadata">Metadata</span>
        </button>
        <mat-divider
          *ngIf="
            hasProperties() &&
            (canDeleteSubmissions() || canDeleteLocationOfInterest())
          "
        ></mat-divider>
        <button
          mat-menu-item
          *ngIf="canDeleteSubmissions()"
          (click)="deleteSubmissions()"
        >
          <mat-icon>delete_sweep</mat-icon>
          <span i18n="@@app.loiPanel.deleteSubmissions"
            >Delete submissions</span
          >
        </button>
        <button
          mat-menu-item
          *ngIf="canDeleteLocationOfInterest()"
          (click)="deleteLoi()"
        >
          <mat-icon>delete</mat-icon>
          <span i18n="@@app.loiPanel.deleteLoi">Delete site</span>
        </button>
      </mat-menu>
      <button mat-icon-button aria-label="back" (click)="onClosePanel()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <ng-container *ngIf="submissions() as subs">
      <div *ngIf="subs.count() === 0" class="no-lois-container">
        <div class="mat-icon-container">
          <mat-icon>inbox</mat-icon>
        </div>
        <span i18n="@@app.loiPanel.noDataForThisSite"
          >No data collected for this site</span
        >
      </div>

      <mat-list *ngIf="subs.count() > 0">
        <div *ngFor="let submission of subs; let i = index">
          <mat-divider *ngIf="i > 0"></mat-divider>
          <div class="submission-item">
            <mat-list-item (click)="onSelectSubmission(submission.id)">
              <mat-icon matListItemIcon>text_snippet</mat-icon>
              <h3 matListItemTitle>
                {{ submission.created.user.displayName }}
              </h3>
              <p matListItemLine>
                {{ submission.created.clientTime | date: 'longDate' }}
              </p>
            </mat-list-item>
            <button mat-icon-button (click)="onSelectSubmission(submission.id)">
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>
        </div>
      </mat-list>
    </ng-container>
  </ng-container>
</div>
